/**
 * Email Link
 */

// Vendors
import $ from 'jquery';
import { copyToClipboard } from '../lib/utilities';

$('[href^="mailto"]:not([data="nocopy"])').on('click', (event) => {
  event.preventDefault();
  const regex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
  const self = $(event.currentTarget);
  self.addClass('email-link--copied');
  const href = self.attr('href');
  const email = href.match(regex);

  if (email.length) {
    copyToClipboard(email[0]);

    setTimeout(() => {
      self.removeClass('email-link--copied');
    }, 2000);
  }
});

$('[data="email-template"]').on('click', (event) => {
  event.preventDefault();

  const $self = $(event.currentTarget);

  $self.addClass('email-template--copied');

  const href = $self.attr('href');

  copyToClipboard(href);

  setTimeout(() => $self.removeClass('email-template--copied'), 2000);
});
